<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct"><a href="#/MontanaLegacy_toc#prol-1">P<span class="small">ROLOGUE</span></a></h1>
<p class="img"><img alt="art" src="images/Art_PLine.jpg"/></p>
<p class="da"><em>Montana—1988</em></p>
<p class="cotx"><span class="dropcap">L</span>ast one to circle Treasure Chest Butte is a dirty, rotten skunk.” Ten-year-old Jesse McCord urged his horse into a gallop,
         leaving his cousins, nine-year-old Wyatt and seven-year-old Zane, in his dust.
      </p>
<p>The three cousins lived with their parents and grandparents in a sprawling, three-story house on their grandfather’s ranch,
         Lost Nugget, which covered thousands of acres of rangeland in Montana. Because of the vast size of their families’ holdings
         and the distance to the nearest town of Gold Fever, the three were homeschooled and spent much of their spare time exploring
         the hills and rich grassland that formed the perfect backdrop for the thousands of head of cattle that were raised here.
      </p>
<p>The three were alike in coloring, with dark, curly hair, now slick with sweat, and their grandfather’s laughing blue eyes.
         In town they were often mistaken for brothers, which pleased them enormously. They were, in fact, closer than brothers. Not
         just blood-related, but best friends. Since birth, they’d done everything together.
      </p>
<p>“Hey, wait for me.” As always, Zane, the youngest, had to scramble to catch up.</p>
<p>By the time he and Wyatt slid from their mounts, Jesse was kneeling beside a fallen log, fishing something from the dirt.</p>
<p>“What’d you find, Jesse?” Wyatt looped the reins of his horse around a nearby sapling and crept closer to drop down beside
         his cousin. Zane mimicked his older cousin’s actions.
      </p>
<p>High above them, the peaks of Treasure Chest Mountain glistened gold in the late summer sunlight.</p>
<p>Jesse held up a dull bronze-veined stone the size of his fist. “Looks like a nugget.”</p>
<p>“Gold?” The two boys watched with rapt attention as Jesse turned it this way and that, grinning each time it caught and reflected
         the sun.
      </p>
<p>“Could be. Or it could be fool’s gold.” He rubbed it on his sleeve, hoping to clean away some of the dirt. “Coot’s got a shelfful
         of fool’s gold.”
      </p>
<p>“Is it heavy enough to be real gold?” Wyatt held out his hand and Jesse dropped the stone into his palm. After testing it,
         he grinned. “I don’t know what real gold ought to feel like.”
      </p>
<p>Jesse shrugged. “Me neither.”</p>
<p>“Let me see.” Zane closed his hand around the nugget and felt the heat of the sun-warmed earth radiating from it. He looked
         up. “You think it’s part of the lost treasure Grandpa Coot’s been searching for his whole life?”
      </p>
<p>The three cousins exchanged eager glances.</p>
<p>Everyone in the McCord family knew the story of their ancestor Jasper McCord, and the sack of gold nuggets he and his son
         Nathaniel had found at Grasshopper Creek in 1862, which was later stolen by another prospector, Grizzly Markham. Though Markham
         was found dead scant weeks later, the sack of nuggets was never found, and rumor had it that he’d buried the treasure somewhere
         nearby after slitting Jasper’s throat. That was how Treasure Chest Mountain, the town of Gold Fever, and even the McCord ranch,
         Lost Nugget, came by their names. Now, following the lead of three generations before them, the McCord family continued the
         search, much to the scorn of folks around these parts, who believed that the gold carried a curse. Hadn’t it consumed the
         lives of every McCord male?
      </p>
<p>Jesse broke off a low-hanging tree limb and began pushing it into the dirt. When it was firmly planted he took out a handkerchief
         and tied it to the top.
      </p>
<p>Wyatt eyed it. “What’s that for?”</p>
<p>“We need to mark the spot so Grandpa Coot knows where to dig if this turns out to be real gold.” Jesse pocketed the nugget,
         then, enjoying the drama of the moment, looked around to make certain no one was nearby. He felt a tingling at the base of
         his skull. What if it turned out to be part of the lost treasure?
      </p>
<p>This was, he realized, why his grandfather continued the search, despite all odds.</p>
<p>His voice lowered to a whisper. “We have to keep this a secret. We can’t tell a soul except Grandpa Coot. We have to swear
         an oath.”
      </p>
<p>The two younger boys nodded solemnly, looking to Jesse to show them how.</p>
<p>Jesse spit in his hand, and the other two followed suit. Then the three rubbed hands, mingling their saliva, while Jesse said,
         “I swear to God I’ll tell nobody except Coot about this gold.” He looked properly stern. “Now you have to swear it.”
      </p>
<p>“I swear,” Wyatt said.</p>
<p>Zane swallowed, feeling the weight of this momentous occasion weighing heavily on his young shoulders before saying, “I swear.”</p>
<p>Jesse pulled himself into the saddle and waited for the other two to mount.</p>
<p>As they started toward the distant ranch house he turned in the saddle. “Remember. Since we all swore, if anybody breaks the
         vow, something really bad will happen to them.”
      </p>
<p>“Like what?” Zane brought his horse even with Jesse’s in order to hear every word.</p>
<p>“I don’t know.” Jesse shrugged, thinking about all the adventure novels he’d read as part of his homework assignments. “Maybe
         anybody who breaks the vow will be banished from Lost Nugget ranch forever. Or they’ll die or something.”
      </p>
<p>The three boys slowed their mounts and looked properly worried. Not about death, which seemed too improbable for their young
         minds to conceive. But being banished from the ranch was the worst possible punishment they could ever imagine.
      </p>
<p>Each boy knew he would take his secret to the grave before he’d risk the loss of this place he loved more than anything in
         the whole world.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MontanaLegacy_prol-1.vue?4a66f6c6